export default function unflatten(obj) {
    let result = {};

    Object.keys(obj).forEach(key => {
        const keys = key.split('.');

        if (keys.length > 1) {
            if (!result[keys[0]]) {
                result[keys[0]] = {};
            }

            result[keys[0]][keys[1]] = obj[key];
        } else {
            result[key] = obj[key];
        }
    });

    return result;
}



// WEBPACK FOOTER //
// ./src/utils/unflatten.js